import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { prepareMicrofrontendManifest } from 'shared/mappers/microfrontend';

import {
  fetchGetInfrastructureMicrofrontend,
  IGetInfrastructureMicrofrontendOptions,
  IGetInfrastructureMicrofrontendResponse200,
  TResponse,
} from 'shared/repositories/map-search-frontend/v1/get-infrastructure-microfrontend';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';
import { request } from 'shared/utils/request';

type TParameters = TRequestParamsWithoutHttpApi<
  IGetInfrastructureMicrofrontendOptions<IGetInfrastructureMicrofrontendResponse200>
>;

export const fetchInfrastructureMicrofrontendManifest = async (
  context: IApplicationContext,
  parameters: TParameters,
): Promise<IMicrofrontendManifest | null> =>
  request<IMicrofrontendManifest | null, TParameters, TResponse>(context, {
    parameters,
    domain: 'fetchInfrastructureMicrofrontendManifest',
    defaultValue: null,
    fetchFunction: fetchGetInfrastructureMicrofrontend,
    prepareFunction: prepareMicrofrontendManifest,
  });
